// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"379c4908","442":"c3e72aae","582":"5c4b5660"}[chunkId] + ".chunk.js";
};